module.exports = __webpack_public_path__ + "static/img/banner_aboutus.c88bae9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mobile/english/banner_aboutus.png
// module id = 9mmI
// module chunks = 15